import styled from "styled-components";

const Form = styled.form`
  width: 80rem;
  overflow: hidden;
  font-size: 1.4rem;
`;

export default Form;
